import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getWebDetailShopMenu as getWebDetailShopMenuApi
} from "../../../helpers/backend_helper";

export const getDetailShopMenu = createAsyncThunk("Web/menu/getDetailShopMenu", async (menuId: string) => {
    try {
        const response = await getWebDetailShopMenuApi(menuId);
        return response;
    } catch (error: any) {
        throw error;
    }
});